import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEmojiPlus = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	strokeWidth: 1.5,
	viewBox: "2 2 20 20",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: "inherit",
		d: "M9.75 14.75s.75 1 2.25 1 2.25-1 2.25-1m5-3V12A7.25 7.25 0 1 1 12 4.75h.25m7 2.25h-4.5M17 9.25v-4.5M10 11v.01m4-.01v.01"
	})
});
export default SvgEmojiPlus;
